import {decorate, injectable} from "inversify";
import {Action} from "@dp-instant/core";
import {Core} from "../ported/Base/Core";

export class PauseActionHomoEvolution extends Action {
    async execute(doPause) {
        Core.SetPause(doPause);
    }
}

decorate(injectable(), PauseActionHomoEvolution);
